export default __webpack_public_path__ + "static/media/expl_gradcam_06_DE.deb5b570.png";